import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ReadDocumentsSI,
  ResponseCommonSI,
  UrlFileBucketSI,
} from '@views/interfaces';
import { firstValueFrom } from 'rxjs';
import { BASE_URL, ENDPOINTS } from '@core/config/constants';

@Injectable({
  providedIn: 'root',
})
export class DocumentsService {
  constructor(private http: HttpClient) {}

  async readDocument(
    idDocument: string,
    ask: string
  ): Promise<ReadDocumentsSI> {
    const result = await firstValueFrom<ResponseCommonSI<ReadDocumentsSI>>(
      this.http.get(
        `${BASE_URL}${ENDPOINTS.READ_DOCUMENTO.replace(
          ':idDocument',
          idDocument
        )}?ask=${ask}`
      )
    );
    return result.payload;
  }

  async getContractUrl(url: string): Promise<UrlFileBucketSI> {
    const result = await firstValueFrom<ResponseCommonSI<UrlFileBucketSI>>(
      this.http.post(`${BASE_URL}${ENDPOINTS.GET_URL_DOCUMENT}`, { url })
    );
    return result.payload;
  }

  async savedDocument(id: string): Promise<void> {
    const result = await firstValueFrom<ResponseCommonSI<void>>(
      this.http.post(`${BASE_URL}${ENDPOINTS.SAVED_DOCUMENT}`, {
        id,
      })
    );
    return result.payload;
  }
}
